import React, { type SVGProps } from 'react';
import styled from 'styled-components';

type StepVariant = 'android' | 'ios';
type StepProps = {
	content: string;
	Icon: (props: SVGProps<SVGSVGElement>) => React.JSX.Element;
	title: string;
	variant?: StepVariant;
};

const Step = ({ content, Icon, title, variant }: StepProps) => {
	return (
		<S.Container $variant={variant ?? 'ios'}>
			<S.IconWrapper>
				<Icon height={48} width={48} />
			</S.IconWrapper>
			<S.Content>
				<S.Title>{title}</S.Title>
				{content}
			</S.Content>
		</S.Container>
	);
};

namespace S {
	export const Container = styled.div<{ $variant: StepVariant }>`
		display: flex;
		flex-direction: column;
		flex: 1 0 0;
		align-self: ${({ $variant }) => ($variant === 'android' ? 'flex-end' : 'stretch')};
		width: ${({ $variant }) => ($variant === 'android' ? '55%' : '100%')};
		padding: ${({ theme }) => `${theme.spacings.xsmall} ${theme.spacings.xxsmall}`};
	`;
	export const IconWrapper = styled.div`
		padding-left: ${({ theme }) => theme.spacings.xxsmall};
	`;
	export const Content = styled.div`
		padding: ${({ theme }) => `${theme.spacings.small} ${theme.spacings.xsmall}`};
	`;
	export const Title = styled.h2`
		${({ theme }) => theme.fonts.headings.title5};
		margin: 0;
	`;
}

export default Step;
